module.exports = __webpack_public_path__ + "img/profile.89646f1b.png";